export default function CarouselSuffix(container: Element) {
  if (!container) return;

  const handleItemNumberChange = (ev: Event) => {
    const event = ev as CustomEvent;
    const itemNumber = event.detail;

    container.querySelectorAll(".quantity").forEach((e) => {
      const element = e as HTMLInputElement;
      element.value = "1";
    });

    container
      .querySelectorAll("[data-target=carouselSuffixTarget]")
      .forEach((e) => {
        const element = e as HTMLElement;
        element.hidden = element.dataset.item !== itemNumber.toString();
      });

    container
      .querySelectorAll("[data-target=carouselSuffixOOSTarget]")
      .forEach((e) => {
        const element = e as HTMLElement;
        element.hidden = element.dataset.item !== itemNumber.toString();
      });

    const itemOOS = container.querySelector(
      `[data-target=carouselSuffixOOSTarget][data-item="${itemNumber}"]`,
    );

    const itemATC = container.querySelector(
      "[data-target=carouselSuffixATCTarget]",
    ) as HTMLElement;

    if (itemATC) {
      itemATC.hidden = !!itemOOS;
    }
  };

  if (container.parentElement) {
    container.parentElement.addEventListener(
      "ItemNumber.change",
      handleItemNumberChange,
    );
  }
}
